import { GQPermissionType } from '@watershed/shared-universal/generated/graphql';
import { SourceObjectWithPermissionDelegate } from '@watershed/shared-universal/utils/permissionsHierarchy';
import { useUserContext } from './UserContext';
import { hasPermission } from '@watershed/shared-universal/utils/permissionUtils';

export default function useHasPermission(
  allowList: GQPermissionType | Array<GQPermissionType>,
  options: {
    allowAnyObject?: boolean;
    source?: SourceObjectWithPermissionDelegate;
  } = {}
) {
  const { permissions } = useUserContext();

  if (!Array.isArray(allowList)) {
    allowList = [allowList];
  }

  return hasPermission(permissions, allowList, options);
}
